import { StaticElement } from "@/components/slides/editor/StaticElement";
import { DraggableLine } from "@/components/slides/editor/renderers/DraggableLine";
import { CANVAS_SIZE } from "@/lib/constants/slides";
import { convertElementsToPixels } from "@/lib/utils/elementConversion";
import type { SlideFields } from "@/types/Slide";
import { backgroundColors } from "@ai-teach/canvas-styles";
import type { LineElement } from "@ai-teach/types";
import { resolveSlideTemplate } from "@ai-teach/types";
import type { RefObject } from "react";

interface SlideCaptureCanvasProps {
  slide: SlideFields;
  canvasRef: RefObject<HTMLDivElement>;
}

/**
 * A freeform slide at full canvas size with no editor chrome, for html-to-image to shoot. Unlike
 * the editor canvases it takes the slide as a prop, so any slide can be rendered without opening it.
 */
export function SlideCaptureCanvas({ slide, canvasRef }: SlideCaptureCanvasProps) {
  const elements = convertElementsToPixels(slide.elements, resolveSlideTemplate(slide));

  return (
    <div
      ref={canvasRef}
      className="relative overflow-hidden"
      style={{
        width: CANVAS_SIZE.freeform.size.width,
        height: CANVAS_SIZE.freeform.size.height,
        backgroundColor: backgroundColors.canvasBg,
      }}
    >
      {elements
        .filter((element) => element.type !== "line")
        .map((element) => (
          <StaticElement key={element.id} element={element} />
        ))}

      {elements
        .filter((element) => element.type === "line")
        .map((element) => (
          <DraggableLine key={element.id} element={element as LineElement} />
        ))}
    </div>
  );
}
